import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { BannerService } from './banner.service';
import {IAlert, IBlockOrderAllocAlert} from './banner.model';
import { AppService } from '@irb/app.service';
import { IUserDetails } from '@irb/app.model';
import { HttpErrorResponse } from '@angular/common/http';

@Component({ standalone: false,
  selector: 'irb-common-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  originalData: Array<IAlert> = [];
  filteredData: Array<IAlert> = [];
  blockOrderAllocData: Array<IBlockOrderAllocAlert> = [];
  @Output() update = new EventEmitter<boolean>();

  constructor(private bs: BannerService, private as: AppService) { }

  ngOnInit() {
    this.get();
  }

  get() {
    this.bs.getAlerts().subscribe(data => {
      this.originalData = data as Array<IAlert>;
      this.filteredData = this.originalData.filter(d => (this.bs.dismissedAlerts.indexOf(d.type) == -1));     
      this.update.emit(true);
    });
    this.as.getUserDetails().subscribe((userDetails: IUserDetails) => {
      if(userDetails.isTrader) {
      this.bs.getBlockOrderAllocAlerts().subscribe(data => {
        this.blockOrderAllocData = data as Array<IBlockOrderAllocAlert>;
      });
    }
    });
    
 
  }

    // METHOD CALL COMMENTED IN TEMPLATE
    // dismiss(type: string, index: number) {
    //   var dismissableTypes = ["MMC_INVOICE"];
    //
    //   if(dismissableTypes.indexOf(type) != -1) {
    //     this.bs.dismissAlert(type);
    //   }
    //
    //   this.filteredData.splice(index,1);
    //   this.bs.dismissedAlerts.push(type);
    //
    //   this.as.getUserDetails().subscribe((d: IUserDetails) => {
    //     if(typeof d != "undefined") {
    //       window.sessionStorage.setItem(type + "_" + d.userID, "-1");
    //     }
    //   });
    // }

  getCount(typeList: Array<string>): Observable<number> {
    return new Observable(obs => {
      let c = 0;

      this.filteredData.forEach(d => {
        if(typeList.indexOf(d.type) != -1) {
          c += d.data.count;
        }
      });

      obs.next(c);
    });
  }

  dismissBlockOrderAllocAlerts() {
    if(this.blockOrderAllocData.length > 0) {
      this.bs.dismissBlockOrderAllocAlerts(this.blockOrderAllocData).subscribe(() => {
        this.blockOrderAllocData = [];
      });
    }
  }
}
